import { getBasedUrl } from "./get-based-url.js";
import { isPageUrl } from "./is-page-url.js";
const getEditableUrl = (url, baseUrl) => typeof url !== "string" ? void 0 : isPageUrl(url) ? getBasedUrl(url, baseUrl || "") : url;
export {
  getEditableUrl
};
//# sourceMappingURL=get-editable-url.js.map
